<form [formGroup]="formGroup">
  <div class="row">
    <div class="col-12">
      <label class="control-label">Notes for Content Writer</label>
      <app-components-helptext [key]="'AddEditCustomAction_PageOptimizationNotesForContentWriter'"></app-components-helptext>
    </div>
    <div class="col-9">
      <div class="row">
        <div class="form-group col-12">
          <textarea class="form-control"
            formControlName="notesForContentWriter"
            [formValidation]="notesForContentWriterControl"
            [disabled]="isReadOnly"
            [readonly]="isReadOnly"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-12">
          <label class="control-label">Notes for Implementation Specialist</label>
          <app-components-helptext [key]="'AddEditCustomAction_PageOptimizationNotesForImplementationSpecialist'"></app-components-helptext>
          <textarea class="form-control"
            formControlName="notesForImplementationSpecialist"
            [formValidation]="notesForImplementationSpecialistControl"
            [disabled]="isReadOnly"
            [readonly]="isReadOnly"></textarea>
        </div>
      </div>
    </div>
    <div class="col-3">
      @if (selectedUrl) {
        <app-components-managecustomer-target-keywords [selectedUrl]="selectedUrl"></app-components-managecustomer-target-keywords>
      }
    </div>
  </div>
</form>